import React from 'react';

const ContactPage = () => {
  return (
    <div className="max-w-7xl mx-auto p-12">
      {/* Breadcrumb Navigation */}
      <nav className="flex items-center text-sm mb-8">
        <a href="#" className="text-gray-500 hover:text-gray-700">Home</a>
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-gray-700">Contact</span>
      </nav>

      {/* Main Content Container */}
      <div className="flex flex-col md:flex-row gap-6 mt-20">
        {/* Left Column - Contact Info */}
        <div className="w-full md:w-1/3 bg-white rounded-lg shadow p-6">
          {/* Call To Us Section */}
          <div className="mb-6">
            <div className="flex items-center mb-4">
              <div className="h-10 w-10 rounded-full bg-purple-600 flex items-center justify-center mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-lg font-medium">Call To Us</h3>
            </div>
            <p className="text-gray-600 text-sm mb-2">
              We are available 24/7, 7 days a week.
            </p>
            <p className="text-gray-800 text-sm">
              Phone: +00 1122334455667
            </p>
          </div>
          
          <div className="border-t border-gray-200 my-6"></div>
          
          {/* Write To Us Section */}
          <div>
            <div className="flex items-center mb-4">
              <div className="h-10 w-10 rounded-full bg-purple-600 flex items-center justify-center mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-medium">Write To US</h3>
            </div>
            <p className="text-gray-600 text-sm mb-2">
              Fill out our form and we will contact you within 24 hours.
            </p>
            <div className="text-gray-800 text-sm">
              <p className="mb-1">Email: customer@example.com</p>
              <p>Email: support@example.com</p>
            </div>
          </div>
        </div>

        {/* Right Column - Contact Form */}
        <div className="w-full md:w-2/3 bg-white rounded-lg shadow p-6">
          <form className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <input 
                  type="text" 
                  className="w-full px-4 py-2 bg-gray-100 border border-gray-200 rounded-md focus:outline-none"
                  placeholder="Your Name *"
                />
              </div>
              <div>
                <input 
                  type="email" 
                  className="w-full px-4 py-2 bg-gray-100 border border-gray-200 rounded-md focus:outline-none"
                  placeholder="Your Email *"
                />
              </div>
              <div>
                <input 
                  type="tel" 
                  className="w-full px-4 py-2 bg-gray-100 border border-gray-200 rounded-md focus:outline-none"
                  placeholder="Your Phone *"
                />
              </div>
            </div>
            
            <div>
              <textarea 
                className="w-full px-4 py-2 bg-gray-100 border border-gray-200 rounded-md h-40 focus:outline-none"
                placeholder="Your Message"
              ></textarea>
            </div>
            
            <div className="flex justify-end">
              <button 
                type="submit" 
                className="px-6 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 focus:outline-none"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;